export default __webpack_public_path__ + "static/Arthur-eb080106ac71a86cb98ebeb409e3d63f.jpg";